export interface DIN276CategoryMetadata {
  code?: string;
  name?: string;
}

const normalizeDIN276Value = (value: unknown) => String(value ?? "").trim();

export const resolveDIN276CategoryCode = (
  value: unknown,
  metadata: DIN276CategoryMetadata[] = [],
) => {
  const needle = normalizeDIN276Value(value);
  if (!needle) return "";

  // Codes win over names, so the lowercase needle is built once and each list is walked directly.
  let match: DIN276CategoryMetadata | undefined;
  for (const category of metadata) {
    if (normalizeDIN276Value(category?.code) === needle) {
      match = category;
      break;
    }
  }
  if (!match) {
    const lowerNeedle = needle.toLowerCase();
    for (const category of metadata) {
      if (normalizeDIN276Value(category?.name).toLowerCase() === lowerNeedle) {
        match = category;
        break;
      }
    }
  }

  return match?.code ? normalizeDIN276Value(match.code) : needle;
};

export const din276CategoryMatchesFilter = (
  value: unknown,
  selectedCode: unknown,
  metadata: DIN276CategoryMetadata[] = [],
) => {
  const filterCode = normalizeDIN276Value(selectedCode);
  if (!filterCode) return true;

  return resolveDIN276CategoryCode(value, metadata) === filterCode;
};
